const questionMixin = {
    data() {
        return {
            minNumberOfQuestions: 3,
            types: [],
            statuses: [],
            templates: [],
            questions: [],
            testing: { id: '', title: '' },
            question: { id: '', answers: [], },
            answers: [],
            confirmityAnswers: [],
            answer: {
                id: '',
                answerKy: '',
                answerRu: '',
                trueAnswer: false,
                trueAnswerKy: '',
            },
            loadSelects: false,
            filterForm: {},
            form: {
                id: null,
                questionKy: '',
                questionRu: '',
                descriptionRu: '',
                descriptionKy: '',
                section: '',
                sectionKy: '',
                trueAnswerKy: '',
                trueAnswerRu: '',
                status: true,
                typeId: 1,
                testId: '',
                answers: [],
                conformity: [],
                photoUrl: '',
                photoBase64: null,
            },
        }
    },
    computed: {
        testId() {
            return this.$route.query.testingId;
        },
    },
    methods: {
        saveQuestion( questionId ) {
            if ( questionId )
                return this.axios.put( this.$config.urls.question.fetchQuestion.url.replace( ':id', this.questionID ), this.form );
            else
                return this.axios.post( this.$config.urls.question.fetchQuestions.url, this.form );
        },
        fetchFormOptions() {
            return this.axios.get( this.$config.urls.question.fetchFormOptions.url )
                       .then( response => {
                           this.types = this.objectToArray( response.data.data.types, true );
                           this.statuses = this.objectToArray( response.data.data.status, true );
                           this.templates = response.data.data.templates;
                       } ).catch(()=>{});
        },
        fetchTestingQuestions( testingId ) {
            this.axios.get( this.$config.urls.testing.fetchTestingQuestions.url.replace( ':id', testingId ), { params: this.filterForm } )
                .then( response => {
                    this.questions = response.data.data;
                } ).catch(()=>{});
        },
        fetchQuestions() {
            this.axios.get( this.$config.urls.question.fetchQuestions.url )
                .then( response => {
                    this.questions = response.data.data;
                } ).catch(()=>{});
        },
        fetchQuestion( questionId, isEdit = false ) {
            return this.axios.get( this.$config.urls.question.fetchQuestion.url.replace( ':id', questionId ) )
                       .then( response => {
                           if ( isEdit ) {
                               for ( let prop in response.data.data ) {
                                   if ( response.data.data.hasOwnProperty( prop ) && this.form.hasOwnProperty( prop ) )
                                       this.form[prop] = response.data.data[prop];
                               }
                    
                           }
                           this.question = response.data.data;
                       } ).catch(()=>{});
        },
        fetchQuestionTesting( testingId ) {
            if ( testingId )
                return this.axios.get( this.$config.urls.testing.fetchTest.url.replace( ':id', testingId ) )
                           .then( response => {
                               this.testing = response.data.data;
                               return response.data.data;
                           } ).catch(()=>{});
        },
        deleteQuestion( questionId, testingId = null ) {
            this.$snotify.confirm( this.getTranslation( 'deleteConfirmMsg' ), {
                showProgressBar: false,
                closeOnClick: false,
                backdrop: 0.5,
                buttons: [
                    {
                        text: this.getTranslation( 'yes' ), action: ( toast ) => {
                            this.axios.delete( this.$config.urls.question.fetchQuestion.url.replace( ':id', questionId ) )
                                .then( () => {
                                
                                    if ( testingId )
                                        this.fetchTestingQuestions( testingId );
                                    else
                                        this.fetchQuestions();
                                
                                    this.$snotify.remove( toast.id );
                                    setTimeout( () => {
                                        this.snotifySuccess( 'deleteSuccessMsg' );
                                    } );
                                } ).catch( () => {
                                this.snotifyError( 'serverError' );
                            } );
                        }, bold: true
                    },
                    { text: this.getTranslation( 'no' ), action: ( toast ) => this.$snotify.remove( toast.id ) }
                ]
            } );
        },
        editQuestion( questionId, testingId = null ) {
            if ( testingId )
                return this.$router.push( { name: 'api.question.update', params: { id: questionId }, query: { testingId: testingId } } ).catch(()=>{});
            
            return this.$router.push( { name: 'api.question.update', params: { id: questionId } } ).catch(()=>{});
        },
        updateHeading() {
            this.setHeadings( {
                title: this.getTranslation( 'addingQuestion' ) + ' (' + this.testing.title + ', ' + this.$store.getters['test/getQuestionCount'] + ')',
                breadcrumbs: [
                    {
                        label: this.getTranslation( 'testingTypes' ),
                        route: { name: 'api.testing.getList' }
                    },
                    {
                        label: this.testing.title,
                    }
                ],
                toBack: {
                    label: this.testing.title,
                    route: { name: 'api.testing.get', params: { id: this.testing.id } }
                }
            } );
        }
    },
};
export default questionMixin;
